const anexoObsTrigger = document.querySelector('#adicionarAnexoObs');
const anexosInput = $('#anexosObs');
const dataTransferAnexos = new DataTransfer();
const Lang = require('lang');
const container = $('#listagem-anexos');
let editLength = container.find('.anexos-item').length || 0;
const ga4 = require('../ga4/ga4');

/**
 * Lida com o disparo de click para abrir o input de anexo de observação
 */
function handleAttachClick() {
  anexosInput.click();
}

/**
 * Verifica se o tamanho do arquivo que esta no input excedeu o limite
 *
 */
function validateFileSize(file) {
  const fileSize = file.size / 1024 / 1024;
  // if (fileSize > window.uploadMaxSize) {
  if (fileSize >= 6) {
    bootbox.alert({
      title: Lang.get('js/src/functions/FilePicker.ops'),
      message: Lang.get('js/src/functions/FilePicker.maximum_file_size_exceeded', { max_size: 5 }),
      size: 'small'
    });
    return false;
  }
  return true;
}


/**
 * Valida os tipos dos arquivos inseridos
 */
function validateFiles(files) {
  const formats = ['jpeg', 'png', 'jpg', 'pdf'];
  for (let i = 0; i < files.length; i++) {
    const file = files.item(i);

    if (!validateFileSize(file)) { return false; }

    else if (!formats.includes(file.type.split('/')[1])) {
      bootbox.alert({
        title: Lang.get('js/src/functions/FilePicker.ops'),
        message: Lang.get('js/src/functions/FilePicker.invalid_ext'),
        size: 'small'
      });
      return false;
    }
  }
  return true;
}

/**
 * Lida com a inserção de arquivos no input de anexo de observação
 */
function handleAttachChange(e) {
  const df = dataTransferAnexos.items.length;
  const length = this.files.length;

  if ((df + length + editLength) > 3 || (length > 3 && df == 0)) {
    $('#attach-error').show();
    this.files = dataTransferAnexos.files;
    return dataTransferAnexos.files;
  }
  $('#attach-error').hide();

  if (!validateFiles(this.files)) {
    this.files = dataTransferAnexos.files;
    return;
  }

  for (let i = 0; i < this.files.length; i++) {
    const link = $('<a />', { text: this.files.item(i).name });
    const icon = $('<i />', { class: 'fa fa-times delete-anexo' });
    const item = $('<div />', { class: 'anexos-item' });
    item.append(link, icon);
    container.append(item);
    icon.on('click', handleAttachRemove);
    // Adiciona o arquivo novo à lista
    dataTransferAnexos.items.add(this.files.item(i));
  };

  ga4.event('expensesModal_obsAttachments')();

  // Atualiza a lista com os novos itens
  this.files = dataTransferAnexos.files;
}

/**
 * Lida com a remoção de arquivos no input de anexo de observação
 */
function handleAttachRemove(e) {
  const id = $(this).attr('id');
  $('#attach-error').hide();

  // Se existir um id, o arquivo já está cadastrado e é adicionado na listagem de  id's à serem deletados
  if (id) {
    const form = $(this).closest('form');
    const input = $(`<input class="deletedAttachments hidden" name="deletedAttachments[]" value="${id}"/>`)
    form.append(input);
    $(this).parent().fadeOut().remove();
    editLength--;
    return;
  }

  const name = $(this).parent().find('a').text();
  $(this).parent().remove();
  for (let i = 0; i < dataTransferAnexos.items.length; i++) {
    if (name === dataTransferAnexos.items[i].getAsFile().name) {
      // Remove o item da lista
      dataTransferAnexos.items.remove(i);
      break;
    }
  }

  ga4.event('-expensesModal_removeObsAttachments')();

  // Atualiza o input com os arquivos filtrados
  anexosInput[0].files = dataTransferAnexos.files;
}

/**
 * Aplicando os listener nos elementos de anexos
 */
function applyListenerAttachObs() {
  if (anexoObsTrigger) {
    anexoObsTrigger.addEventListener('click', handleAttachClick);
    anexosInput.on('change', handleAttachChange);
    $('.delete-anexo').on('click', handleAttachRemove);
  }
}

exports.init = applyListenerAttachObs;
